import * as types from '../constants/ActionTypes';

const initialState = {
  items: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_BREADCRUMB:
      return Object.assign({}, state, { items: action.payload });
    case types.RESET_BREADCRUMB:
      return Object.assign({}, state, { items: [] });
    default:
      return state;
  }
}
